import { FormSectionHandler } from '../entity.handler';
import { DeviceTypeResponse, DeviceTypeUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { CheckListField, ArrayComboValueHandlers } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    cached_fields?: string[];
}

export class DeviceTypeCachedIoSectionHandler implements FormSectionHandler<DeviceTypeResponse, EditorValues> {

    type = 'form';
    icon = ICONS.iotype;
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DEVICETYPE.CACHED.${key}`, values);
    }

    applyUpdate(entity: DeviceTypeResponse, payload: DeviceTypeUpdateRequest): Promise<DeviceTypeResponse> {
        return this.admin.applyUpdate(api => api.entities.updateDeviceType(entity.id, payload));
    }

    async mapEntityToEditor(entity: DeviceTypeResponse): Promise<EditorValues> {
        return {
            cached_fields: entity && entity.ioCapabilities && entity.ioCapabilities.cached_fields || [],
        };
    }

    async mapEditorToEntity(_entity: DeviceTypeUpdateRequest, values: EditorValues): Promise<DeviceTypeUpdateRequest> {
        return {
            ioCapabilities: {
                cached_fields: values.cached_fields,
            },
        };
    }

    async getFields(entity: DeviceTypeResponse): Promise<FormBuilderField[]> {
        let values = [];
        if (entity.ioCapabilities) {
            ['can_input', 'digital_input', 'digital_output'].forEach(key => {
                values = [...values, ...Object.keys(entity.ioCapabilities[key] || {})];
            });
        }
        return [
            CheckListField('cached_fields', this.translate('FIELDS.CACHED_FIELDS'), false, values.map(key => ({ key: key, value: key })), ArrayComboValueHandlers),
        ].filter(x => x);
    }

}
